module.exports = __webpack_public_path__ + "static/img/cont43_04.59dbd2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont43_04.jpg
// module id = yrze
// module chunks = 0